import { useSelector } from 'react-redux';

import Grid from '@anwb/poncho/components/grid';
import { getCurrentStepNumber } from 'utils/navigation';

import { checkoutBeginsSelector, isFlexSelector, isOccasionSelector } from '../../store/selectors';
import { Receipt } from '../Receipt';

import { GridAsideStyled } from './RequestFlow.styled';
import { CrossSell } from './components/CrossSell';
import { ErrorMessagePage } from './components/ErrorMessagePage';
import { ServicesHealthError } from './components/ServicesHealthErrorNotification';
import { useCheckoutBeginsEvent } from './hooks/useCheckoutBeginsEvent';
import { useHealthStatus } from './hooks/useHealthStatus';
import { useLeaseCarData } from './hooks/useLeaseCarData';
import { useResetPricePoint } from './hooks/useResetPricePoint';
import { useThankYouError } from './hooks/useThankYouError';
import { RequestFlowNavigation } from './steps';

export const RequestFlow = () => {
	const currentStepNumber = getCurrentStepNumber();
	const isOccasion = useSelector(isOccasionSelector);
	const isFlex = useSelector(isFlexSelector);
	const checkoutBegins = useSelector(checkoutBeginsSelector);
	const { carLoading, errorMessage } = useLeaseCarData(currentStepNumber);
	const { thankYouError } = useThankYouError();
	const isAtThankYouStep = currentStepNumber === 4;

	const { isAppHealthy } = useHealthStatus({
		isOccasion,
		isFlex,
		currentStepNumber,
	});

	useCheckoutBeginsEvent();

	useResetPricePoint();

	if (!isAppHealthy && !checkoutBegins && !isAtThankYouStep) {
		return <ServicesHealthError />;
	}

	if (errorMessage) {
		return <ErrorMessagePage errorMessage={errorMessage} />;
	}

	return (
		<Grid.Group>
			{!carLoading && (
				<Grid justify="center" constrainedWidth>
					<RequestFlowNavigation />
					<GridAsideStyled isSticky>
						<Grid.Item>
							{!isAtThankYouStep && <Receipt />}
							{isAtThankYouStep && !thankYouError && <CrossSell />}
						</Grid.Item>
					</GridAsideStyled>
				</Grid>
			)}
		</Grid.Group>
	);
};
